// React
import { memo } from "react";

// Services
import { initialDataWithPagination } from "services/api/consts";

// UI Components
import { TableSearch } from "ui/components/Table/TableSearch";

// Constants
import { CALCUALTION_VEHICLE_GROUP_VEHICLES_SEARCH_COLUMNS } from "./consts";

// Types
import { VehicleGroupSearchResultsProps } from "./types";


const VehicleGroupSearchResults: React.FC<
  VehicleGroupSearchResultsProps
> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
  } = props;

  return (
    <>
      <TableSearch
        columns={CALCUALTION_VEHICLE_GROUP_VEHICLES_SEARCH_COLUMNS}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={false}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};
export default memo(VehicleGroupSearchResults);
